package com.milta.feature.packagelabelscan.domain.usecase

import com.milta.feature.packagelabelscan.domain.entity.PackageLabelScanResult
import com.milta.feature.packagelabelscan.domain.repository.PackageLabelScanRepository

/** POST /api/v1/package-label-scans — écran B du mockup MIL-25. */
class ScanPackageLabelUseCase(private val repository: PackageLabelScanRepository) {
    suspend operator fun invoke(fileBytes: ByteArray, fileName: String): PackageLabelScanResult =
        repository.scanLabel(fileBytes, fileName)
}
